export const SUBSCRIPTION_PLANS_REQUEST = "SUBSCRIPTION_PLANS_REQUEST";
export const SUBSCRIPTION_PLANS_RECEIVE = "SUBSCRIPTION_PLANS_RECEIVE";